import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrRW: CultureInfo = {
  name: 'fr-RW',
  displayName: 'français (Rwanda)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-RW',
  parent: CultureInfoFr
};
